module.exports = {"542229100":"加查镇","542229101":"安绕镇","542229200":"拉绥乡","542229201":"崔久乡","542229202":"坝乡","542229203":"冷达乡","542229204":"洛林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542229.json
// module id = 2754
// module chunks = 0